import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from "react";
import * as IconComponents from "./icons";
import classNames from "classnames";
import { Typography } from "./Typography";
import { ThemeProviderContext } from "./ThemeProvider";
export const variants = [
    "informational",
    "error",
    "attention",
    "success",
    "brand",
    "brand-accent",
];
const sizes = ["normal", "small"];
const defaultIconName = (variant) => {
    switch (variant) {
        case "error":
            return "Error";
        case "attention":
            return "Warning";
        case "success":
            return "SuccessCircle";
        case "brand":
        case "brand-accent":
            return "VtsLogoNoText";
        default:
            return "LightBulb";
    }
};
export const InlineNotice = ({ variant = "informational", iconName = defaultIconName(variant), content, testId, className, size = "normal", }) => {
    const theme = useContext(ThemeProviderContext);
    const colorClassName = {
        informational: [
            "bg-general-blue-quaternary",
            "dark:bg-general-blue-quaternary-darkmode",
        ],
        error: ["bg-background-critical", "dark:bg-background-critical-darkmode"],
        attention: [
            "bg-general-yellow-quaternary",
            "dark:bg-general-yellow-quaternary-darkmode",
        ],
        success: [
            "bg-general-green-quaternary",
            "dark:bg-general-green-quaternary-darkmode",
        ],
        brand: [
            "bg-general-indigo-quaternary",
            "dark:bg-general-indigo-quaternary-darkmode",
        ],
        "brand-accent": [
            "bg-general-aqua-quaternary",
            "dark:bg-general-aqua-quaternary-darkmode",
        ],
    };
    const Icon = IconComponents[`${iconName}Icon`];
    return (_jsxs("div", { style: { overflowWrap: "anywhere" }, className: classNames("inline-flex", size === "normal" && "p-1", size === "small" && "p-0.5", "rounded", "w-full", colorClassName[variant], className), [theme.testAttribute]: testId, children: [_jsx(Icon, { size: size === "normal" ? "md" : "sm", className: classNames("mr-1 mt-[1px]", size === "normal" && "min-h-[18px] min-w-[18px]", size === "small" && "min-h-[14px] min-w-[14px]") }), _jsx(Typography, { variant: size === "small" ? "body-small" : "body-medium", color: "text-primary", children: content })] }));
};
//# sourceMappingURL=InlineNotice.js.map